import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";
export default class SaveExchangeRateDetails {
    static buildRequest(pReq) {
        let returnValue = null;
        try {
            let body = [

            ];
            for (let pReqItem = 0; pReqItem < pReq.length; pReqItem++) {
               delete pReq[pReqItem].created_at;
                // let bodyObj = {
                //     "from_currency": pReq[pReqItem].from_currency,
                //     "to_currency": pReq[pReqItem].to_currency,
                //     "exrate": pReq[pReqItem].exrate,
                // };
                body.push(pReq[pReqItem]);
            }


            returnValue = body;
        }
        catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_SAVE_EXCHANGE_RATE, "error in building body for SaveExchangeRateDetail api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.SAVE_EXCHANGE_RATE, pReqOptions);
        }
        catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_SAVE_EXCHANGE_RATE, "error in getting Response from  SaveExchangeRateDetail api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }
}